import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaBed, FaBath, FaRulerCombined } from "react-icons/fa";
import { API_URL } from "../../../config/api"; 

export default function PropertyInfoCard({ item }) {

  if (!item) {
    return (
      <div className="border rounded-lg p-3 text-gray-500 bg-white shadow-sm">
        Đang tải dữ liệu bất động sản...
      </div>
    );
  }

  let parsedImages = [];

  try {
    if (Array.isArray(item.images)) {
      parsedImages = item.images;
    } else if (typeof item.images === "string") {
      const trimmed = item.images.trim();
      if (trimmed.startsWith("[")) {
        parsedImages = JSON.parse(trimmed);
      } else if (trimmed) {
        parsedImages = [trimmed]; // string đơn lẻ
      }
    }
  } catch (e) {
    console.error("Lỗi parse images:", e);
  }

  const imageSrc = parsedImages[0]
    ? parsedImages[0].startsWith("http")
      ? parsedImages[0]
      : `${API_URL}${parsedImages[0]}`
    : "/placeholder.jpg";



  return (
    <Link
      to={`/properties/${item?.id}`}
      className="border rounded-lg overflow-hidden shadow-sm hover:shadow-md transition bg-white"
    >
      <img
        loading="lazy"
        src={imageSrc}
        alt={item?.projectName || "Bất động sản"}
        className="w-full h-48 object-cover"
      />

      <div className="p-3 text-blue-900 space-y-1">
        <h3 className="font-semibold text-base">{item?.projectName ?? "Đang cập nhật..."}</h3>
        <p className="text-sm text-gray-600 line-clamp-2">{item?.description ?? "—"}</p>
        <div className="flex justify-between text-sm mt-1">
          <span><FaBed className="inline mr-1" />{item?.bedrooms ?? "—"} PN</span>
          <span><FaBath className="inline mr-1" />{item?.bathrooms ?? "—"} WC</span>
          <span><FaRulerCombined className="inline mr-1" />{item?.area ? `${item.area} m²` : "—"}</span>
        </div>
        <p className="text-red-600 font-bold text-lg">
          {item?.price ? `${item.price.toLocaleString("vi-VN")} ₫` : "Giá liên hệ"}
        </p>
        <p className="text-xs text-gray-500">
          <FaMapMarkerAlt className="inline mr-1" />{item?.location ?? "—"}
        </p>
      </div>
    </Link>
  );
}
